import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { Observable } from 'rxjs';
import { REST_SERVER_HOST, SCHOOLBELLE_LOGIN_FRONT_HOST } from '../tokens/index';
import { LocalStorageService } from '@schoolbelle/common/local-storage';
import { v4 as uuid } from 'uuid';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '@schoolbelle/common/loading';

@Injectable({
  providedIn: 'root'
})
export class LoginViaThirdPartiesService {
  constructor(
    private http: HttpClient, private auth: AuthService,
    private storage:LocalStorageService,
    private route:ActivatedRoute,
    private router:Router,
    private loading:LoadingService,
    @Inject(REST_SERVER_HOST) private serverHost:string,
    @Inject(SCHOOLBELLE_LOGIN_FRONT_HOST) private frontHost:string,
  ) {
    this.route.queryParams.subscribe((queryParams)=>this.handleQueryParamsChange(queryParams))
  }
  private handleQueryParamsChange (queryParams:any) {
    this.storage.get('state').then(state_sent=>{
      const access_token = queryParams.access_token;
      const state_returned = queryParams.state;  
      if (state_returned && state_returned === state_sent && state_returned.match(/^schoolbelle/) && access_token) {
        // 0. delete state from storage
        this.storage.remove('state');
        // 1. ask server to checkin for userinfo with this access_token and to return login access token 
        // 2. login with token received from server 
        const subscription = this.loginWIthSchoolbelleToken(access_token)
        .subscribe(()=>{
          this.router.navigateByUrl(this.route.snapshot.queryParams.return || '/main');
        });
        this.loading.open({message:'ë¡ê·¸ì¸ ì¤ìëë¤...', busy:subscription});
      }
    })
  }

  loginViaSchoolbelle () {
    const params = new URLSearchParams();
    const state = `schoolbelle|${uuid()}`;
    this.storage.set('state', state).then(()=>{
      params.append('redirect_uri', window.location.href);
      params.append('response_type', 'token');
      params.append('client_id', 'sbesurvey');
      params.append('state', state);
      const url = `${this.frontHost}?${params.toString()}`
      window.location.replace(url);
    });
  }

  private loginWIthSchoolbelleToken(access_token): Observable<any> {
    return this.http
      .post(
        `${this.serverHost}/api/login/schoolbelle`,
        { access_token },
        { responseType: 'text' }
      )
      .pipe(
        switchMap(customToken => {
          return this.auth.signInWithCustomToken(customToken);
        })
      );
  }
}
